/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { TourResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface IndexPublicTourServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * List of public tours
     * Filter by &#x60;type&#x60;, &#x60;status&#x60;, &#x60;userId&#x60;, &#x60;externalUserId&#x60;. Example &#x60;/tours?filter[type]&#x3D;1&#x60;
     * @param perPage 
     * @param page 
     */
    getPublicTours(perPage?: number, page?: string, extraHttpRequestParams?: any): Observable<Array<TourResource>>;

}
